export enum CarDocumentType {
  CAR_IMAGE = 'CAR_IMAGE',
  ORDER_CONFIRMATION = 'ORDER_CONFIRMATION',
  REGISTRATION_CERTIFICATE = 'REGISTRATION_CERTIFICATE',
  FINANCING_CONTRACT = 'FINANCING_CONTRACT',
  PURCHASE_CONTRACT = 'PURCHASE_CONTRACT',
  COC = 'COC',
  OTHER = 'OTHER',
}
